import { Modal, SkeletonLoader } from '@toggle/design-system';
import React from 'react';

import { useDocuments } from '~/react-query-hooks/documents/useDocumentsEntity';
import { DocumentViewer } from '~/views/alfred/document-search/document-viewer/DocumentViewer';

import styles from './DocumentModal.module.scss';
import { useDocumentModal } from './useDocumentModal';

export const DocumentModal = () => {
  const { isOpen, activeDocumentId, closeModal } = useDocumentModal();
  const { data, isFetching, isError } = useDocuments([activeDocumentId ?? '']);
  const document = data?.[0];

  const getContent = () => {
    if (isFetching) {
      return (
        <div className={styles.skeletonLoaderWrapper}>
          <SkeletonLoader
            areas={[
              {
                styles: {
                  width: '100%',
                  height: '100%',
                  borderRadius: '8px',
                },
              },
            ]}
          />
        </div>
      );
    }

    if (!document || isError) {
      return null;
    }

    return (
      <div className={styles.contentWrapper}>
        <DocumentViewer
          selectedCitation={{
            document_id: document.id,
            document_name: document.name,
            document_type: document.type,
            pages: [],
          }}
          highlightTexts={[]}
          showHeader={false}
        />
      </div>
    );
  };

  return (
    document && (
      <Modal
        className={styles.documentModal}
        isOpen={isOpen}
        onClose={closeModal}
        title={`${document.name}.${document.type}`}
      >
        {getContent()}
      </Modal>
    )
  );
};
